const Request = require('@/repositories/request')
const qs = require('qs')

class Slider extends Request {
  /**
   *
   * @param {Object} params
   * @return {*}
   */
  findAll(params) {
    const stringifyParams = qs.stringify({ ...params }, { encode: false })
    return this.$strapi.$sliders.find(stringifyParams)
  }
}

module.exports = Slider
